import React from 'react'
import Navbar from "../Include/Navbar";
import Footer from "../Include/Footer";
function CancellationPolicy() {
  return (
    <>
    <Navbar/> 
    <div className="about-page">
      <div className="container">
        <h1>Cancellation Policy</h1>
        <p>
          Thank you for choosing <strong>INNOSUTRA AI PRIVATE LIMITED</strong>.
          We offer subscription-based digital services and products, including
          wallpapers, AI-powered assistant services and other digital content.
        </p>
        <p>
          Please read our Subscription Cancellation Policy carefully before
          subscribing.
        </p>
        <section className="section">
          <h2>1. Subscription Plans</h2>
          <p>
            Our services are offered on a recurring subscription basis
            (monthly, quarterly, yearly, or as applicable). By subscribing, you
            authorize automatic recurring payments through your selected payment
            method, including UPI AutoPay or other supported payment methods.
          </p>
        </section>
        <section className="section">
          <h2>2. Cancellation of Subscription</h2>
          <p>You may cancel your subscription at any time.</p>
          <p>Once cancelled:</p>
          <ul>
            <li>
              Your subscription will remain active until the end of the current
              billing cycle.
            </li>
            <li>
              No further recurring payments will be charged after cancellation.
            </li>
            <li>
              Access to premium content and features will expire at the end of
              your active subscription period.
            </li>
          </ul>
        </section>
        <section className="section">
          <h2>3. How to Cancel</h2>
          <p>To cancel your subscription, you can:</p>
          <ul>
            <li>
              Log in to your account and manage your subscription settings, or
            </li>
            <li>
              Contact our support team at:
              innosutraaiprivatelimited@gmail.com
            </li>
          </ul>
          <p>
            Cancellation requests should be submitted at least 24 hours before
            the next billing date to avoid the next recurring charge.
          </p>
        </section>
        <section className="section">
          <h2>4. Refund Policy</h2>
          <p>
            Subscription payments are generally non-refundable once charged.
          </p>
          <p>
            However, refunds may be considered in exceptional circumstances such
            as:
          </p>
          <ul>
            <li>Duplicate payment</li>
            <li>Technical billing errors</li>
            <li>
              Unauthorized transactions (subject to verification)
            </li>
          </ul>
          <p>
            Refund requests must be submitted within 7 days of the transaction
            date.
          </p>
        </section>
        <section className="section">
          <h2>5. Free Trials (If Applicable)</h2>
          <p>
            If a free trial is offered, you may cancel anytime before the trial
            period ends to avoid being charged.
          </p>
          <p>
            If not cancelled before expiry, the subscription will automatically
            convert into a paid subscription.
          </p>
        </section>
        <section className="section">
          <h2>6. Failed Payments</h2>
          <p>
            If recurring payment authorization fails, we may retry the payment
            or suspend access to premium services until payment is successfully
            completed.
          </p>
        </section>
        <section className="section">
          <h2>7. Changes to Subscription Plans</h2>
          <p>
            We reserve the right to modify subscription pricing, features, or
            billing terms. Any changes will be communicated in advance.
          </p>
        </section>
        <section className="section">
          <h2>8. Contact Us</h2>
          <p>
            If you have any questions regarding subscription cancellation or
            billing, please contact us:
          </p>
          <p>
            <strong>Email:</strong>{' '}
            innosutraaiprivatelimited@gmail.com
          </p>
          <p>
            <strong>Company Name:</strong> INNOSUTRA AI PRIVATE LIMITED
          </p>
        </section>
        <section className="section">
          <p>
            By subscribing to our services, you acknowledge and agree to this
            Subscription Cancellation Policy for <strong>Dharmiq App</strong>.
          </p>
        </section>
      </div>
    </div>
    <Footer/>
    </>
  )
}
export default CancellationPolicy